import React from "react";
import { Link } from "react-router-dom";
import { EVENT_LOCATION } from "../constants/eventDetails";

const LetsDoIt = () => {
  return (
    <>
      <section className="position-relative">
        <div className="container">
          <div className="ticket-inner w-lg-75 mx-auto text-center position-relative text-white">
            <div className="ticket-title">
              <h5 className="text-white mb-1">DON'T MISS OUT</h5>
              <h1 className="text-white mb-2">
                HAVEN'T REGISTERED YET?{" "}
                <span className="pink">SECURE YOUR FREE ENTRY NOW!</span>
              </h1>
            </div>
            <div className="ticket-info">
              <p class="text-grey">
                Registration for{" "}
                <b class="text-white">PROFINEXPO BANGKOK 2026</b> is completely
                free! Gain access to expert-led sessions, live exhibition
                booths, high-level networking, and the prestigious ProFX Awards
                Ceremony. Be part of the premier international finance and
                trading event at {EVENT_LOCATION}.
              </p>
              <div className="ticket-button">
                <Link to="/Booknow" className="btn">
                  Book Your Free Ticket Now
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LetsDoIt;
